import { Button, ConfigProvider, Flex } from 'antd';
import { ReactComponent as MaximiseMap } from '../../../assets/maximise-map.svg';
import { ReactComponent as MinimiseMap } from '../../../assets/minimise-map.svg';
import PropTypes from 'prop-types';
const FullScreenToggle = ({ isFullScreen, onClick }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultBg: '#ffffff',
            defaultHoverBg: '#ffffff',
            defaultBorderColor: '#ffffff',
            defaultHoverBorderColor: '#ffffff',
          },
        },
      }}
    >
      <Flex
        gutter={10}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
        }}
        className="toggle-fullscreen"
      >
        <Button
          size="small"
          icon={isFullScreen ? <MinimiseMap /> : <MaximiseMap />}
          onClick={onClick}
        />
      </Flex>
    </ConfigProvider>
  );
};

FullScreenToggle.propTypes = {
  isFullScreen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default FullScreenToggle;
